module.exports = __webpack_public_path__ + "img/open_access_webdoc.081a840e.jpg";